<template>
  <div
    :class="[
      'indicator-heading',
      { 'linked-title': linkedTitle && !hideBorder },
    ]"
  >
    <v-container fluid class="pa-0">
      <!-- Title and Score Row -->
      <v-row align="center" no-gutters>
        <v-col cols="10" class="pa-0">
          <template v-if="linkedTitle">
            <a
              href="#"
              class="text-decoration-none"
              @click.prevent="emit('open-glossary')"
            >
              <h2 class="font-weight-bold">
                <slot name="title"></slot>
              </h2>
            </a>
            <div class="sub-title">
              <slot name="sub-title"></slot>
            </div>
          </template>
          <template v-else>
            <h2 class="font-weight-bold text-secondary">
              <slot name="title"></slot>
            </h2>
          </template>
        </v-col>
        <v-col cols="2" class="pa-0 text-right">
          <h2 class="text-h6 text-secondary">
            <slot name="score"></slot>
          </h2>
        </v-col>
      </v-row>
      <!-- Description Row -->
      <v-row no-gutters>
        <v-col cols="12" class="pa-0">
          <p class="mt-4">
            <slot name="description"></slot>
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
  import { defineEmits } from 'vue';

  interface Props {
    linkedTitle?: boolean;
    hideBorder?: boolean;
  }

  withDefaults(defineProps<Props>(), {
    linkedTitle: false,
    hideBorder: false,
  });

  const emit = defineEmits(['open-glossary']);
</script>

<style lang="scss" scoped>
  .indicator-heading {
    p {
      font-size: 16px;
      line-height: 1.5rem;
    }
    a {
      color: rgb(var(--v-theme-primary)) !important;
      text-decoration: underline !important;
      h2 {
        font-size: 18px !important;
      }
    }
    &.linked-title {
      margin-bottom: 18px;
      border-bottom: 1px solid
        rgba(var(--v-border-color), var(--v-border-opacity));
    }
    :deep(.sub-title) {
      margin-top: 8px;
      font-size: 14px !important;
      .sub-title-score {
        margin-left: 8px;
      }
    }
  }
</style>
